export const getValidDate = (input?: string): Date => {
  if (input) {
    const values = input.split('/');
    const date = new Date();
    const day = Number(values[0]) || date.getDay();
    const month = Number(values[1] || 1) - 1;
    const year =
      (values[2] && values[2].length !== 4 ? Number(values[2]) + 2000 : Number(values[2])) || date.getFullYear();

    return new Date(year, month, day);
  }
  return new Date();
};

// AAAA-MM-JJ
export const formatDateReverse = (date: Date): string =>
  date &&
  // locale : fr-CA to have AAAA-MM-JJ format
  // timezone: to not lose one day on date
  date.toLocaleString('fr-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric' });

// AAAAMMJJ
export const formatDateForBadges = (date: Date): string => {
  // locale : fr-CA to have AAAA-MM-JJ format
  // timezone: to not lose one day on date
  return date
    .toLocaleString('fr-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric' })
    .replace(/-/g, '');
};
